module.exports = __webpack_public_path__ + "img/4_台湾1(1).5a6caae4.jpg";